/* hp-thumb-fit.js — Galerie-Thumbnails: Formate-Regel (Entscheid Tobias 2026-07-30,
 * Artifact «PDP-Thumbnails: Formate-Konzept» v2, Memory pdp-thumbnails-formate).
 *
 * Regel: PRODUKTBILDER (weisser oder durchsichtiger Hintergrund) bleiben zu 100%
 * unangetastet — an ihnen ändert sich kein Pixel. NUR Lifestyle-Fotos und
 * Video-Vorschaubilder werden in die Kachel gezoomt (object-fit: cover), damit
 * die grauen Balken bei Hoch-/Querformaten verschwinden.
 *
 * Erkennung pro Bild (einmalig, Ergebnis pro Session gecacht): 6 Randpunkte des
 * Thumbnails (150px-Variante) — sind mindestens 5 davon weiss ODER durchsichtig,
 * gilt das Bild als Produktbild. Shopify-CDN liefert CORS-Header, darum ist der
 * Canvas-Pixel-Check mit crossOrigin=anonymous möglich. Bei jedem Fehler
 * (Canvas tainted, Netz, decode) passiert NICHTS — Fallback ist immer das
 * heutige Verhalten (contain), es kann also nie schlechter werden als vorher.
 *
 * Die Thumb-Leiste wird vom Theme/Varianten-Bilderfilter re-rendert (lazy
 * loading, Variantenwechsel) → MutationObserver wendet die Klasse erneut an.
 * Plain ES5 IIFE, keine Dependencies.
 */
(function () {
  if (window.__hpThumbFitInstalled) return;
  window.__hpThumbFitInstalled = true;

  // localStorage statt sessionStorage (2026-08-02): Das Urteil pro Bild ist dauerhaft
  // gültig — es hängt nur am Bildinhalt. Mit sessionStorage wurde in JEDEM neuen Tab
  // neu klassiert, also sah der Kunde das Nachspringen praktisch bei jedem Besuch.
  // Fällt localStorage aus (Privatmodus, volle Quota), greift der In-Memory-Cache und
  // das Verhalten ist exakt das alte.
  var CACHE_KEY = 'hpThumbFit.v1';
  var store = null;
  try { store = window.localStorage; store.getItem(CACHE_KEY); } catch (e) { store = null; }
  var cache = {};
  try { cache = JSON.parse((store && store.getItem(CACHE_KEY)) || '{}') || {}; } catch (e) { cache = {}; }
  var saveT = null;
  function saveCache() {
    clearTimeout(saveT);
    saveT = setTimeout(function () {
      if (!store) return;
      try { store.setItem(CACHE_KEY, JSON.stringify(cache)); } catch (e) {}
    }, 400);
  }

  // Normalisierter Cache-Schlüssel: Pfad ohne Query (width-Varianten teilen das Urteil).
  function keyFor(src) {
    try { return src.split('?')[0]; } catch (e) { return src; }
  }

  // Randpunkte messen. Wirft, wenn die Canvas durch ein nicht-CORS-Bild vergiftet ist.
  function messe(quelle) {
    var c = document.createElement('canvas');
    c.width = quelle.naturalWidth; c.height = quelle.naturalHeight;
    if (!c.width || !c.height) return null;
    var ctx = c.getContext('2d');
    ctx.drawImage(quelle, 0, 0);
    var w = c.width, h = c.height;
    var pts = [[2, 2], [w - 3, 2], [2, h - 3], [w - 3, h - 3], [Math.floor(w / 2), 2], [Math.floor(w / 2), h - 3]];
    var clean = 0;
    for (var i = 0; i < pts.length; i++) {
      var d = ctx.getImageData(pts[i][0], pts[i][1], 1, 1).data;
      if (d[3] < 250 || (d[0] > 242 && d[1] > 242 && d[2] > 242)) clean++;
    }
    return clean >= 5;
  }

  // true = Produktbild (nicht anfassen), false = Foto/Video (cover), null = unbekannt.
  // el = das bereits sichtbare Thumbnail. Trägt es crossorigin="anonymous" und ist es
  // fertig geladen, messen wir DIREKT daran — kein zweiter Download, kein Nachspringen.
  // Sonst (altes Markup, fremde Quelle) exakt der bisherige Weg über ein Zweitbild.
  function classify(src, el, done) {
    var k = keyFor(src);
    if (k in cache) { done(cache[k]); return; }
    if (el && el.complete && el.naturalWidth && (el.crossOrigin === 'anonymous' || el.getAttribute('crossorigin') === 'anonymous')) {
      var direkt = null;
      try { direkt = messe(el); } catch (e) { direkt = null; }
      if (direkt !== null) { cache[k] = direkt; saveCache(); done(direkt); return; }
      // Vergiftete Canvas oder Messfehler → unten den alten Weg versuchen.
    }
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      var result = null;
      try { result = messe(im); } catch (e) { result = null; }
      cache[k] = result;
      saveCache();
      done(result);
    };
    im.onerror = function () { cache[k] = null; saveCache(); done(null); };
    im.src = src;
  }

  // Die zwei Theme-Slider (zuletzt angesehen / Empfehlungen) stehen über die
  // Theme-Einstellung prod_card_image_fit auf «cover» — dort ist die Basis also
  // umgekehrt: Ein Produktbild muss aktiv auf contain ZURÜCK, sonst wird es an den
  // Seiten beschnitten (Tobias 2026-08-12, Versa Gripps Pro: Bild 316x275 in einer
  // Kachel von 216x216). Bewusst NUR diese zwei Slider, weil nur sie
  // hp-slider-card.css laden und dort ohnehin das Ziel gilt, wie die
  // Kategoriekarte auszusehen (HIG-43).
  var SLIDER_SEL = '.cc-recently-viewed .card__media img, .cc-product-recommendations .card__media img, .cc-featured-collection .card__media img'; // 02.09.2026: auch Startseiten-Karussells (featured-collection)

  function apply() {
    // Seit 2026-08-12 auch die Kategoriekarten (.hp-card__image, inkl. Karussell-
    // Slides): Tobias will, dass die Bilder dort den Rahmen füllen — nach genau
    // derselben Regel wie auf der Produktseite. Produktbilder auf Weiss bleiben
    // also auch dort unbeschnitten, Lifestyle-Fotos werden gezoomt.
    var imgs = Array.prototype.slice.call(document.querySelectorAll('.media-thumbs__btn img, .hp-card__image, ' + SLIDER_SEL));
    // Speed-AP4 WP4: Haeppchenweise im Leerlauf (max. ~6 ms pro Durchgang), statt alle
    // Bilder in einem Rutsch. Sichtbare Bilder zuerst, damit nichts sichtbar nachspringt.
    var vh = window.innerHeight || 800;
    imgs.sort(function (a, b) {
      var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
      var va = ra.bottom > 0 && ra.top < vh ? 0 : 1, vb = rb.bottom > 0 && rb.top < vh ? 0 : 1;
      return va - vb;
    });
    var idx = 0;
    function chunk(deadline) {
      var t0 = Date.now();
      while (idx < imgs.length && (deadline && deadline.timeRemaining ? deadline.timeRemaining() > 1 : Date.now() - t0 < 6)) {
        handle(imgs[idx++]);
      }
      if (idx < imgs.length) idle(chunk, { timeout: 2000 });
    }
    idle(chunk, { timeout: 2000 });
    function handle(img) {
      (function (img) {
        var src = img.currentSrc || img.src;
        if (!src || img.getAttribute('data-hp-fit') === src) return;
        img.setAttribute('data-hp-fit', src);
        var los = function () {
          classify(src, img, function (isProduct) {
            var imSlider = false;
            try { imSlider = img.matches(SLIDER_SEL); } catch (e) {}
            if (imSlider) {
              // Basis dort ist cover → nur das Produktbild zurück auf contain holen.
              img.classList.toggle('hp-thumb--contain', isProduct === true);
            } else {
              // false = Foto/Video → zoomen; true/null = unangetastet lassen.
              img.classList.toggle('hp-thumb--cover', isProduct === false);
            }
          });
        };
        // Noch nicht decodiert? Dann erst messen, wenn es da ist — sonst fiele es
        // unnötig auf den Zweitdownload zurück.
        if (img.complete) los();
        else img.addEventListener('load', los, { once: true });
      })(img);
    }
  }

  // Entprellt: Die Kategoriekarte ruft refresh() nach jedem Bildwechsel auf
  // (Variantenwahl, Karussell-Aufbau). Ein globaler MutationObserver über das
  // Boost-Grid wäre auf einer Kategorieseite mit 36 Karten deutlich teurer.
  var applyT = null;
  function applySoon() {
    clearTimeout(applyT);
    applyT = setTimeout(apply, 120);
  }

  // Speed-AP4 WP4 (2026-09-01): Die Klassifikation (Canvas drawImage + getImageData pro
  // Bild) lief bisher sofort bei DOMContentLoaded und blockierte den Main-Thread 0.7-1.0 s
  // VOR dem LCP (PDP mit 47 Thumbs, Kategorie mit 36 Karten). Sie ist rein kosmetisch
  // (Zuschnitt-Klasse) und darf deshalb warten: Erstlauf erst nach window.load im
  // Browser-Leerlauf, und apply() arbeitet die Bilder in kleinen Haeppchen ab, damit
  // kein einzelner Long Task entsteht. Verhalten/Ergebnis sonst unveraendert.
  var idle = window.requestIdleCallback || function (cb) { return setTimeout(function () { cb({ timeRemaining: function () { return 8; } }); }, 200); };
  function afterLoad(fn) {
    if (document.readyState === 'complete') { idle(fn, { timeout: 3000 }); return; }
    window.addEventListener('load', function () { idle(fn, { timeout: 3000 }); }, { once: true });
  }

  function init() {
    afterLoad(apply);
    var strip = document.querySelector('.media-gallery__thumbs');
    try {
      if (strip) {
        new MutationObserver(function () { apply(); }).observe(strip, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
      }
      // Die beiden Slider holen ihren Inhalt asynchron über die Section-API nach
      // (<recently-viewed data-url>, <product-recommendations data-url>). Beim
      // ersten apply() existieren ihre Bilder also noch gar nicht — ohne diesen
      // Beobachter bliebe die Formate-Regel dort wirkungslos. Die zwei Custom
      // Elements stehen ab dem ersten HTML im DOM, nur eben leer.
      var lazy = document.querySelectorAll('recently-viewed, product-recommendations');
      for (var i = 0; i < lazy.length; i++) {
        new MutationObserver(applySoon).observe(lazy[i], { childList: true, subtree: true });
      }
    } catch (e) {}
  }

  // Von assets/hp-collection-card.js aufgerufen, sobald eine Karte ein neues Bild hat.
  window.HPThumbFit = { refresh: applySoon, apply: apply };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
